import { DialogActionsBar } from '@progress/kendo-react-dialogs';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import LinkIcon from 'src/assets/icons/LinkIcon';
import Button from 'src/components/design-system/Button';
import Dialog from 'src/components/design-system/Dialog';
import useAuth from 'src/hooks/useAuth';
import useRedirect from 'src/hooks/useRedirect';
import useGetExternalCatalogMutation from 'src/services/catalog_products/useGetExternalCatalogMutation';
import { useContextSelector } from 'use-context-selector';
import { ViewCatalogProductsContext } from './ViewCatalogProductsContext';

const ExternalCatalogButton = () => {
  const { t } = useTranslation();
  const { redirect } = useRedirect();
  const { siteName } = useAuth();
  const [isPunchOutModalOpen, setIsPunchOutModalOpen] = useState(false);
  const selectedCatalog = useContextSelector(
    ViewCatalogProductsContext,
    (context) => context.selectedCatalog
  );

  const { mutateAsync: fetchExternalCatalog, isPending: isLoadingExternalCatalog } =
    useGetExternalCatalogMutation();

  const handleOpenExternalCatalog = useCallback(async () => {
    if (!selectedCatalog?.catalogId) return;

    try {
      const data = await fetchExternalCatalog(selectedCatalog.catalogId);
      if (data.statusCode === 200 && data.redirectUrl) {
        redirect(data.redirectUrl, true, true);
      } else {
        toast.error(
          t('Unable to open the external catalog. Please connect with the administrator.')
        );
      }
    } catch (error) {
      console.error('Failed to fetch external catalog:', error);
    }
  }, [selectedCatalog?.catalogId, fetchExternalCatalog, redirect, t]);

  const handleViewExternalCatalog = useCallback(() => {
    setIsPunchOutModalOpen(true);
  }, []);

  const handleCloseModal = useCallback(() => {
    setIsPunchOutModalOpen(false);
  }, []);

  const handleOkClick = useCallback(() => {
    setIsPunchOutModalOpen(false);
    handleOpenExternalCatalog();
  }, [handleOpenExternalCatalog]);
  return (
    <div>
      <Button
        color="secondary"
        size="md"
        onClick={handleViewExternalCatalog}
        loading={isLoadingExternalCatalog}
      >
        {t('Open External Catalog')} <LinkIcon />
      </Button>

      <Dialog
        width="500px"
        onClose={handleCloseModal}
        open={isPunchOutModalOpen}
        title={t('Punchout Order Guide')}
        id="modal"
      >
        <div className="p-0 text-sm">
          <div className="mb-3">
            <p>{t('punchoutSessionNewTab')}</p>
          </div>
          <div className="mb-3">
            <p>{t('punchoutAllowPopup')}</p>
          </div>
          <div>
            <p>{t('punchoutSessionDone', { siteName })}</p>
          </div>
        </div>
        <DialogActionsBar>
          <div className="flex items-center justify-end">
            <Button color="info" onClick={handleOkClick}>
              {t('Ok')}
            </Button>
          </div>
        </DialogActionsBar>
      </Dialog>
    </div>
  );
};

export default ExternalCatalogButton;
